import { useEffect, useState, type HTMLAttributes, type ReactNode } from 'react';
import { useDiscreto } from './sensivel';

/**
 * Lista de 30/10 (item 6): a foto do perfil no lugar das iniciais. A foto é uma imagem da API (rota autenticada com o nome
 * do arquivo e a versão, cache imutável do navegador). Volta às iniciais (`children`) quando a pessoa não tem foto, quando a
 * imagem não carrega (versão trocada em outra janela, foto removida) e em TODO o modo discreto: o rosto identifica a pessoa
 * mais que o nome, e o discreto já censura o nome (pontos, ou iniciais com a opção de nomes), então a foto some junto.
 */

export const TAMANHOS_AVATAR = [96, 256] as const;

export const urlAvatar = (usuarioId: string, versao: string, tamanho: (typeof TAMANHOS_AVATAR)[number] = 96) => `/api/v1/nucleo/avatar/${usuarioId}/avatar-${versao}-${tamanho}.webp`;

export function AvatarUsuario({
  usuarioId,
  versao,
  tamanho = 96,
  className = '',
  children,
  ...resto
}: { usuarioId: string; versao?: string | null; tamanho?: (typeof TAMANHOS_AVATAR)[number]; className?: string; children: ReactNode } & Omit<HTMLAttributes<HTMLSpanElement>, 'children' | 'className'>) {
  const { ativo } = useDiscreto();
  const [falhou, setFalhou] = useState(false);
  useEffect(() => setFalhou(false), [versao]);
  const foto = !!versao && !ativo && !falhou;
  return (
    <span {...resto} className={`${className} overflow-hidden`} data-avatar={foto ? 'foto' : 'iniciais'}>
      {foto ? <img src={urlAvatar(usuarioId, versao, tamanho)} alt="" draggable={false} onError={() => setFalhou(true)} className="size-full object-cover" /> : children}
    </span>
  );
}
